<template>
  <div class="my_center">
    <div class="center">
      <h4 style="margin:0 0 10px 10px">个人中心</h4>
      <el-tabs
        :tab-position="tabPosition"
        style="height: 200px;"
      >
        <el-tab-pane label="购买记录">
          <div class="sys">
            <div
              :class="{'clicked':(searchIndex=='')}"
              @click="changeSearch('')"
            >全部</div>
            <div
              :class="{'clicked':(searchIndex==1)}"
              @click="changeSearch(1)"
            >演示系统</div>
            <div
              :class="{'clicked':(searchIndex==2)}"
              @click="changeSearch(2)"
            >设计方案</div>
            <div
              :class="{'clicked':(searchIndex==3)}"
              @click="changeSearch(3)"
            >宣传画册</div>
            <div
              :class="{'clicked':(searchIndex==4)}"
              @click="changeSearch(4)"
            >演示视频</div>
            <div
              :class="{'clicked':(searchIndex==5)}"
              @click="changeSearch(5)"
            >其他</div>
          </div>
          <el-table
            :data="tradeList"
            border
            size="medium"
            style="width: 100%"
            height="400"
          >
            <el-table-column
              prop="systemName"
              width="300"
              label="名称"
            ></el-table-column>
            <el-table-column
              width="300"
              prop="orderNo"
              align="center"
              label="订单号"
            ></el-table-column>
            <el-table-column
              prop="money"
              align="center"
              label="价格"
            ></el-table-column>
            <el-table-column
              prop="payStatus"
              align="center"
              label="支付状态"
              :formatter="formatStatus"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              label="购买时间"
              :formatter="formatTime"
            ></el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="pagesize"
              layout="total, prev, pager, next,sizes,jumper"
              background
              :total="totalCount"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="我的收藏">
          <div class="sys">
            <div
              :class="{'clicked':(searchIndex1=='')}"
              @click="changeSearch1('')"
            >全部</div>
            <div
              :class="{'clicked':(searchIndex1==1)}"
              @click="changeSearch1(1)"
            >演示系统</div>
            <div
              :class="{'clicked':(searchIndex1==2)}"
              @click="changeSearch1(2)"
            >设计方案</div>
            <div
              :class="{'clicked':(searchIndex1==3)}"
              @click="changeSearch1(3)"
            >宣传画册</div>
            <div
              :class="{'clicked':(searchIndex1==4)}"
              @click="changeSearch1(4)"
            >演示视频</div>
            <div
              :class="{'clicked':(searchIndex1==5)}"
              @click="changeSearch1(5)"
            >其他</div>
          </div>
          <el-table
            :data="collectionList"
            border
            size="medium"
            style="width: 100%"
            height="400"
          >
            <el-table-column
              prop="goodsName"
              width="450"
              label="名称"
            >
              <template slot-scope="scope">
                <span
                  @click="goInfo(scope.row.zkGoodsVo)"
                  style="cursor: pointer;"
                >{{scope.row.goodsName}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="downloadNum"
              align="center"
              label="下载量"
            ></el-table-column>
            <el-table-column
              prop="previewNum"
              align="center"
              label="浏览量"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              label="浏览时间"
              :formatter="formatTime"
            ></el-table-column>
            <el-table-column
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="pagesize1"
              layout="total, prev, pager, next,sizes,jumper"
              background
              :total="totalCount1"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getTradeList,
  getCollectionList,
  collectDelete,
  loginUser,
} from "../js/api.js";
export default {
  data() {
    return {
      tabPosition: "left",
      searchIndex: "",
      searchIndex1: "",
      tradeList: [],
      collectionList: [],
      //分页
      totalCount: 10,
      pagesize: 10,
      currentPage: 1,
      totalCount1: 10,
      pagesize1: 10,
      currentPage1: 1,
      searchFrom: {
        goodsType: "",
        pageNum: 1,
        pageSize: 10,
        userId: "string",
      },
    };
  },
  created() {
    this.loginUser();
  },
  methods: {
    async loginUser() {
      let res = await loginUser();
      if (res.data.code == 200) {
        if (res.data.data == null) {
        } else {
          this.searchFrom.userId = res.data.data.id;
          this.getTradeList(this.searchFrom);
          this.getCollectionList(this.searchFrom);
        }
      }
    },
    goInfo(e) {
      sessionStorage.setItem("infoArr", JSON.stringify(e));
       this.$router.push({
        path: "/infoPage",
        query: {
          id: e.id
        },
      });
    },
    //收藏删除
    async handleDelete(index, obj) {
      let res = await collectDelete(obj.id);
      if (res.data.code == 200) {
        this.getCollectionList(this.searchFrom);
        this.$message({
          showClose: true,
          message: res.data.message,
          type: "success",
        });
      }
    },
    //类型列表
    async getTradeList(data) {
      let res = await getTradeList(data);
      if (res.data.code == 200) {
        this.tradeList = res.data.paging.list;
        this.totalCount = Number(res.data.paging.totalCount);
      }
    },
    //类型列表
    async getCollectionList(data) {
      let res = await getCollectionList(data);
      if (res.data.code == 200) {
        this.collectionList = res.data.paging.list;
        this.totalCount1 = Number(res.data.paging.totalCount);
      }
    },
    changeSearch(e) {
      this.currentPage = 1
      this.searchFrom.pageNum = 1;
      this.searchFrom.goodsType = e;
      this.searchIndex = e;
      this.getTradeList(this.searchFrom);
    },
    changeSearch1(e) {
      this.currentPage1 = 1
      this.searchFrom.pageNum = 1;
      this.searchFrom.goodsType = e;
      this.searchIndex1 = e;
      this.getCollectionList(this.searchFrom);
    },
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchFrom.pageSize = val;
      this.getTradeList(this.searchFrom);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchFrom.pageNum = val;
      this.getTradeList(this.searchFrom);
    },
    //分页
    handleSizeChange1(val) {
      this.pagesize1 = val;
      this.searchFrom.pageSize = val;
      this.getCollectionList(this.searchFrom);
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.searchFrom.pageNum = val;
      this.getCollectionList(this.searchFrom);
    },
    formatStatus(row) {
      let val = row.payStatus;
      if (val == 1) {
        return "未支付";
      } else {
        return "已支付";
      }
    },
    //格式化时间
    formatTime(row) {
      let val = row.createTime;
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
  },
};
</script>

<style scoped>
.center {
  width: 1200px;
  margin: auto;
  font-size: 16px;
}

.el-tabs--left {
  height: 500px !important;
}

.is-left {
  font-size: 18px !important;
}

h4 {
  font-size: 20px;
}

.sys {
  display: flex;
  margin-left: 20px;
  margin-bottom: 10px;
}

.sys > div {
  margin-right: 20px;
  cursor: pointer;
  padding: 5px 0;
  color: #9c9c9c;
}

.clicked {
  color: #1859e2 !important;
  border-bottom: 2px solid #1859e2;
}

.el-table {
  background: transparent;
  margin-left: 20px;
}

.el-table /deep/ th,
.el-table /deep/ tr {
  background: transparent;
}
</style>